import {
	createHook,
	createStore,
	createContainer,
	createDefaultEocWrapper,
} from '@atlassian/eoc-rss-helpers';
import { useFlagService } from '@atlassian/jira-flags';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import type { StoreBaseContainerProps } from '../../../common/types';
import { actions } from './actions';
import type { JNAAppStatus } from './types';

export const initialState: JNAAppStatus = {
	loading: false,
	error: null,
};

const Store = createStore({ initialState, actions, name: 'jna-app-status' });

// We have a separate store for this b/c we need to fetch the data higher up in the tree
const JNAAppStatusContainer = createContainer<
	JNAAppStatus,
	typeof actions,
	{ children?: React.ReactNode; isGlobal?: boolean }
>(Store, {
	Wrapper: createDefaultEocWrapper({
		useSyncContainerProps: (): StoreBaseContainerProps => {
			const { cloudId } = useTenantContext();
			const { showFlag } = useFlagService();
			return {
				cloudId,
				showFlag,
			};
		},
	}),
});

const useJNAAppStatus = createHook(Store);

export { useJNAAppStatus, JNAAppStatusContainer };
